<template>
  <CheckboxFilterDropdown
    icon="mdi-format-list-bulleted"
    label="Rows"
    :items="rowItems"
    :selected-ids="visibleIds"
    @toggle="(id, value) => $emit('toggle-field', id, value)"
    @select-all="(value) => $emit('select-all', value)"
  />
</template>

<script setup>
import { computed } from 'vue';
import CheckboxFilterDropdown from '@/components/jobArchitecture/CheckboxFilterDropdown.vue';

const props = defineProps({
  fields: {
    type: Array,
    default: () => [],
  },
  visibleIds: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['toggle-field', 'select-all']);

const rowItems = computed(() => props.fields.map((field) => ({
  id: field.id,
  label: field.label || field.id,
})));
</script>
